import { ComponentProps, useCallback, useLayoutEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { NAVBAR_HEIGHT, PAGE_HEADER_HEIGHT } from '../constants'

type Props = ComponentProps<typeof Link> & ScrollIntoViewOptions

export const HashLink = (props: Props) => {
  const { to, children, behavior = 'smooth', block = 'start', ...rest } = props
  const location = useLocation()
  const [firstRun, setFirstRun] = useState(true)

  const scrollToElement = useCallback(
    (elementId: string) => {
      const element = document.getElementById(elementId)
      if (element) {
        element.style.scrollMarginTop = `${PAGE_HEADER_HEIGHT + NAVBAR_HEIGHT}px`

        if (firstRun) {
          window.scrollTo({
            top:
              element.getBoundingClientRect().top +
              window.scrollY -
              (PAGE_HEADER_HEIGHT + NAVBAR_HEIGHT),
            behavior: 'auto',
          })
          setFirstRun(false)
        } else {
          element.scrollIntoView({ behavior, block })
        }
      }
    },
    [behavior, block, firstRun],
  )

  useLayoutEffect(() => {
    if (location.hash === to) {
      const elementId = to.slice(1)

      requestAnimationFrame(() => scrollToElement(elementId))
    }
  }, [location, scrollToElement, to])

  return (
    <Link
      to={to}
      {...rest}
      state={{
        ignoreLeavingGuard: true,
      }}
    >
      {children}
    </Link>
  )
}
